// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selector_signature .label-wrapper .v-input :not(.v-input--is-focussed)::before {\n  border: none;\n}\n.selector_signature .label-wrapper .v-input .v-input__control .v-input__slot .v-text-field__slot input {\n  font-size: 16px !important;\n}", ""]);
// Exports
module.exports = exports;
